
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IBook} from "@/interfaces/book.interface";
import AppSwitch from "@/components/AppSwitch.vue";
import {isMobileOnly} from "mobile-device-detect";
import moment from "moment";
import {IApp} from "@/interfaces/app.interface";
import _ from "lodash";
import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
import {ICarRequest} from "@/modules/Car/interfaces/car-request.interface";
import {httpResource} from "@/resources/http.resource";
import {bus} from "@/plugins/bus";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({
  components: {AppSwitch}
})
export default class AdditionalBtns extends Vue {
  isMobileOnly = false;

  get storeState(): IAppState { return this.$store.state; }
  get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }
  get createMode() { return this.storeState.car.createMode; }
  get popupPayload(): ICarStore.IPopupPayload { return this.storeState.car.popupPayload; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }
  get parkValues() { return this.storeState.book.books[IBook.BookName.parks]; }

  get modelValue() { return this.formModel.parks; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'parks',
      value
    });
  };

  get extModeFlag() { return this.storeState.auth.userAccess.extModeFlag }
  set extModeFlag(value) { this.$store.dispatch('profile/saveExtModeFlag', { value }); }

  get hasInArchive() { return this.formModel.carStatusId === ICar.CarStatusId.Archive; }

  created() {
    this.isMobileOnly = isMobileOnly;
  }

  async confirmUpdateArchive() {
    if (this.isMobileOnly) this.$emit('visibleDropdown', false);

    if (this.activeCar.carStatusId === ICar.CarStatusId.Parking) {
      this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'car',
        dialogName: 'confirmArchive',
        payload: {
          confirmAction: async () => {
            await this.updateArchiveStatus(true);
          }
        }
      });
      return;
    }

    await this.updateArchiveStatus();
  }

  async updateArchiveStatus(confirmCarLeaveParkFlag = false) {
    let dateInvalid = 'Invalid date';
    let success = await this.$store.dispatch('car/saveCarData', {
      command: this.hasInArchive ? ICarRequest.Command.Update : ICarRequest.Command.Delete,
      car: {
        ...this.formModel,
        corpId: this.hasInArchive && !this.formModel.corpId ? -100 : this.formModel.corpId,
        dateBeg: this.formModel.dateBeg && this.formModel.dateBeg !== dateInvalid ? moment(this.formModel.dateBeg).format(IApp.DateFormats.ToServer) : '',
        dateEnd: this.hasInArchive ? '' : this.formModel.dateEnd && this.formModel.dateBeg !== dateInvalid ? moment(this.formModel.dateEnd).format(IApp.DateFormats.ToServer) : '',
        dateBegTarif: this.formModel.dateBegTarif && this.formModel.dateBegTarif !== dateInvalid ? moment(this.formModel.dateBegTarif).format(IApp.DateFormats.ToServer) : '',
        confirmCarLeaveParkFlag,
      },
      needUpdate: !_.isEqual(this.formModel, this.startForm),
    });
    if (success) {
      this.$notify({
        title: 'Успешно',
        message: this.hasInArchive ? 'Автомобиль восстановлен из архива' : 'Автомобиль отправлен в архив',
        type: 'success'
      });
      bus.$emit(ICarStore.Events.ReloadCarPopupData);
    }
    else {
      this.$notify.error({
        title: 'Ошибка',
        message: this.hasInArchive ? 'Не удалось восстановить из архива' : 'Не удалось добавить в архив',
      });
    }
  }

  async removeCarFromHistory() {
    if (this.isMobileOnly) this.$emit('visibleDropdown', false);
    const carId = this.activeCar.carId;

    // this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
    await this.$store.dispatch('confirm/open', {
      title: 'Внимание',
      text: 'Вы уверены, что хотите удалить данный автомобиль из архива?',
      class: 'danger',
      cancel: {
        text: 'Отменить',
        action: () => {
          // this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
        }
      },
      confirm: {
        text: 'Удалить',
        action: async () => {
          let asyncAction = async () => {
            const action = ICarRequest.Action.CarsMK;
            const params: any = {
              command: ICarRequest.Command.RemoveFromHistory,
              carId,
              carNumber: this.formModel.carNumber,
              corpId: this.formModel.corpId,
            };
            const response = await httpResource.httpAction({ action, params });
            this.$store.commit('carList/removeCarFromList', carId);
            this.$notify({
              title: 'Успешно',
              message: `Автомобиль ${this.formModel.carNumber} был удален из архива.`,
              type: 'success'
            });
            await this.$store.dispatch('car/closeCarPopup');
          };
          await this.$store.dispatch('defaultResourceAction', { asyncAction });
          // this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
        },
      },
    });
  }

  async openCashPay() {
    if (this.isMobileOnly) this.$emit('visibleDropdown', false);
    this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
    await this.$store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'cashPayPopup',
      payload: {
        ...this.popupPayload,
        formModel: {
          carNumber: this.formModel.carNumber,
          tsum: this.popupPayload.cashSum,
          parkId: this.popupPayload.cashParkId,
          corpId: this.formModel.corpId,
        },
        closeAction: () => this.$store.commit('car/setProperty', { name: 'displayContent', value: true }),
      }
    });
  }
}
